import assessment from '@/api/assessment'
import person from '@/api/person'
import { assessment as AssessmentModel } from '@/api/models'
import { mergeUserContext } from '@/store/helpers'

// Someday we will make this an API call vs. statically set here
// Either way our form will be "config" driven which makes altering it much easier
const assessmentFields = [
  // Uncategorized
  {
    name: 'q_safe',
    label: 'Feels Safe'
  },
  /* {
    name: 'i_fearful_of_others',
    label: 'Fearful of Others'
  },
  {
    name: 'i_false_age',
    label: 'Does not give real age'
  },
  */

  // physical
  {
    name: 'i_injuries',
    label: 'Bruises/Injuries',
    category: 'physical'
  },
  {
    name: 'i_sti',
    label: 'STIs',
    category: 'physical'
  },
  {
    name: 'i_tattoos',
    label: 'Neck or chest tattoos/tattoos with names',
    category: 'physical'
  },
  {
    name: 'i_drug_alcohol_use',
    label: 'Evidence of drug or alcohol use',
    category: 'physical'
  },
  {
    name: 'i_expensive_items',
    label: 'In possession of expensive items without means to obtain them',
    category: 'physical'
  },
  {
    name: 'i_hotel_keys',
    label: 'Evidence of hotel keys',
    category: 'physical'
  },
  {
    name: 'i_cash',
    label: 'Large Amounts of Unexplained Cash',
    category: 'physical'
  },
  {
    name: 'i_multiple_phones',
    label: 'Multiple cell phones',
    category: 'physical'
  },
  {
    name: 'i_manner_of_dress',
    label: 'Manner of dress',
    category: 'physical'
  },
  {
    name: 'i_condoms',
    label: 'Possession of condoms and/or lingerie',
    category: 'physical'
  },
  {
    name: 'i_history_abuse',
    label: 'History of sexual abuse',
    category: 'physical'
  },
  {
    name: 'i_manicures',
    label: 'Expensive manicures or hairstyles',
    category: 'physical'
  },
  {
    name: 'i_no_identification',
    label: 'Lack of identification',
    category: 'physical'
  },

  // Behavioral
  {
    name: 'i_anxious',
    label: 'Extremely Anxious to End Interview',
    category: 'behavioral'
  },
  {
    name: 'i_trouble_speaking',
    label: 'Has Trouble Speaking for Herself / Himself',
    category: 'behavioral'
  },
  {
    name: 'i_moves_around',
    label: 'Frequently Moves Around to Different Cities',
    category: 'behavioral'
  },
  {
    name: 'i_the_life_language',
    label: 'Language Specific to Being in "The Life"',
    category: 'behavioral'
  },
  {
    name: 'i_no_eye_contact',
    label: 'Avoids Eye Contact',
    category: 'behavioral'
  },
  {
    name: 'i_withholds_demographic',
    label: 'Withholds real name, age or other demographic information',
    category: 'behavioral'
  },
  {
    name: 'i_truancy',
    label: 'Truancy or Not Enrolled in School at All',
    category: 'behavioral'
  },
  {
    name: 'i_speaks_for_them',
    label: 'Accompanied by someone who speaks on their behalf',
    category: 'behavioral'
  },
  {
    name: 'i_showing_deference',
    label: 'Accompanied by someone to whom they show deference, fear or hyper-attentiveness',
    category: 'behavioral'
  },
  {
    name: 'i_runaway',
    label: 'Runaway History',
    category: 'behavioral'
  },
  {
    name: 'i_unrelated_adult',
    label: 'Child Accompanied by Unrelated Adult',
    category: 'behavioral'
  },

  // Psychological

  {
    name: 'i_scripted',
    label: 'Scripted Answers',
    category: 'psychological'
  },
  {
    name: 'i_flat_affect',
    label: 'Flat Affect',
    category: 'psychological'
  },
  {
    name: 'i_fearful',
    label: 'Generally Fearful or Lacks Appropriate Level of Fear',
    category: 'psychological'
  },

  {
    name: 'i_hyperarousal',
    label: 'Signs of Hyperarousal',
    category: 'psychological'
  },

  {
    name: 'i_memory_gaps',
    label: 'Gaps in Memory',
    category: 'psychological'
  },

  {
    name: 'i_savvy',
    label: 'Overly Savvy or Confident / Mature Beyond Years',
    category: 'psychological'
  },

  // Medical
  {
    name: 'i_suicidal_ideation',
    label: 'Suicidal ideation or suicide attempt',
    category: 'psychological'
  },
  {
    name: 'i_self_injury',
    label: 'History of self-injurious behavior',
    category: 'medical'
  },
  {
    name: 'i_assault',
    label: 'Presenting with acute sexual or physical assault',
    category: 'medical'
  },
  {
    name: 'i_sleep_deprivation',
    label: 'Presenting with disorientation from sleep deprivation or intoxication',
    category: 'medical'
  },
  {
    name: 'i_poor_dentition',
    label: 'Poor dentition',
    category: 'medical'
  },
  {
    name: 'i_lack_of_care',
    label: 'Evidence of chronic lack of care',
    category: 'medical'
  },
  {
    name: 'i_multiple_pregancies',
    label: 'History of multiple pregnancies or terminated pregnancies',
    category: 'medical'
  },
  {
    name: 'i_contraception',
    label: 'History of multiple visits for emergency contraception',
    category: 'medical'
  }

]

// initial state
const state = {
  allAssessments: [],
  viewAssessment: _.clone(AssessmentModel),
  createAssessment: _.clone(AssessmentModel),
  editAssessment: _.clone(AssessmentModel),
  recentlyCreatedAssessment: false,
  assessmentPerson: _.clone(AssessmentModel),
  personAssessments: [],
  personAssessmentsResponse: false,
  showAssessmentCreatedModal: false,
  showAssessmentUpdatedModal: false,
  assessmentsCount: 0,
  errors: false,
  assessmentFields: assessmentFields
}

// getters
const getters = {
  getAllAssessments: state => state.allAssessments,
  getViewAssessment: state => state.viewAssessment,
  getCreateAssessment: state => state.createAssessment,
  getRecentlyCreatedAssessment: state => state.recentlyCreatedAssessment,
  getEditAssessment: state => state.editAssessment,
  getAssessmentPerson: state => state.assessmentPerson,
  showAssessmentCreatedModal: state => state.showAssessmentCreatedModal,
  showAssessmentUpdatedModal: state => state.showAssessmentUpdatedModal,

  // Used on Person screen
  getAssessmentsByPerson: state => state.personAssessments,
  getPersonAssessmentsResponse: state => state.personAssessmentsResponse,

  // May be unused
  getAssessmentsCount: state => state.assessmentsCount,

  // Used for displaying assessment information
  getAssessmentFields: state => state.assessmentFields
}

// actions
const actions = {
  async getAssessmentsCount ({ commit, state, rootState }, payload) {
    payload = payload || {}
    payload = mergeUserContext(payload, rootState)

    var response = await assessment.getAssessmentsCount(payload)
    commit('setAssessmentsCount', response.body)

    return response.data
  },

  async getAssessments ({ commit, state, rootState }, payload) {
    payload = payload || {}
    payload = mergeUserContext(payload, rootState)

    var response = await assessment.getAssessments(payload)
    commit('setAssessments', response.body)

    return response
  },

  async getAssessment ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await assessment.getAssessment(payload)

    // This is because we're hitting the find() blueprint and not the findOne()?
    if (_.isArray(response.body)) {
      response = response.body.pop()
    }

    commit('setAssessment', response)
  },

  async createAssessment ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    var response = await assessment.createAssessment(payload)
    response = response.body

    if (response.error) {
      state.error = response.error
      state.errors.push(state.error)
    } else {
      commit('setShowAssessmentCreatedModal', true)
      commit('setRecentlyCreatedAssessment', response)
      commit('setCreateAssessment', _.clone(AssessmentModel))

      // TO DO - might be best to add it to personAssessments
      // We probably don't need to add it to the All Assessments list?
      commit('addToAssessmentsList', response)
    }
  },

  // Single View - Edit
  async getAssessmentForEdit ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await assessment.getAssessment(payload)

    // TO DO - Is this because we're hitting the find() blueprint and not the findOne()?
    if (_.isArray(response.body)) {
      response = response.body.pop()
    }

    commit('setEditAssessment', response)
  },

  // Single View - Edit
  async getAssessmentPerson ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await person.getPerson(payload)
    commit('setAssessmentPerson', response.body[0])
  },

  // Update/Edit
  async updateAssessment ({ commit, state, rootState }, payload) {
    delete payload.sharingGroups
    delete payload.organizationCreator
    delete payload.organizationOwner
    delete payload.person

    payload = mergeUserContext(payload, rootState)

    // Ensure we don't try to update the assessments array
    if (payload.assessments) {
      delete payload.assessments
    }

    if (_.isObject(payload.person)) {
      payload.person = payload.person._id
    }

    var response = await assessment.updateAssessment(payload)
    response = response.body

    // Only show modal if everything went okay
    if (response) {
      commit('setShowAssessmentUpdatedModal', true)
      commit('updateAssessmentsList', response)
    }

    if (!response) {
      // TO DO - Set something where we can surface server errors
    }
  },

  async getAssessmentsByPerson ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    payload = payload || {}
    var response = await assessment.getAssessments(payload)
    response.body.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt)
    })
    console.log(response.body)
    response = response.body

    if (_.isArray(response)) {
      commit('setPersonAssessments', response)
    } else {
      // TO DO - Set an error
      commit('SET_PERSON_ASSESSMENTS_RESPONSE', response)
    }
  }
}

// mutations
const mutations = {
  setAssessmentsCount (state, count) {
    state.assessmentsCount = count
  },

  setAssessments (state, records) {
    if (!_.isEmpty(records)) {
      state.allAssessments = records
    }
  },

  setAssessment (state, record) {
    if (!record) {
      record = _.clone(AssessmentModel)
    }

    state.viewAssessment = record
  },

  resetAssessment (state) {
    state.viewAssessment = _.clone(AssessmentModel)
  },

  setCreateAssessment (state, record) {
    state.createAssessment = record
  },

  resetCreateAssessment (state, record) {
    state.createAssessment = _.clone(AssessmentModel)
  },

  setRecentlyCreatedAssessment (state, record) {
    state.recentlyCreatedAssessment = record
  },

  resetEditAssessment (state, record) {
    state.editAssessment = _.clone(AssessmentModel)
  },

  setEditAssessment (state, record) {
    state.editAssessment = record
  },

  setAssessmentPerson (state, record) {
    if (_.isEmpty(record)) {
      state.assessmentPerson = _.clone(AssessmentModel)
    } else {
      state.assessmentPerson = record
    }
  },

  setShowAssessmentCreatedModal (state, response) {
    state.showAssessmentCreatedModal = response
  },

  setShowAssessmentUpdatedModal (state, response) {
    state.showAssessmentUpdatedModal = response
  },

  addToAssessmentsList (state, newRecord) {
    var oldIndex = _.findIndex(state.allAssessments, (r) => r.id === newRecord.id)

    if (oldIndex < 0) {
      state.allAssessments.unshift(newRecord)
    } else {
      // Uh-oh - we tried to add a record that's already in our list
    }
  },

  // After updating someone, update them in the list
  updateAssessmentsList (state, updatedRecord) {
    // Find person in all persons
    var oldIndex = _.findIndex(state.allAssessments, (r) => r.id === updatedRecord.id)

    if (oldIndex >= 0) {
      // Remove old record and Add new updated record
      state.allAssessments = state.allAssessments.splice(oldIndex, 1, updatedRecord)
    }
  },

  setPersonAssessments (state, records) {
    if (!_.isEmpty(records)) {
      state.personAssessments = records
    } else {
      state.personAssessments = []
    }
  },

  SET_PERSON_ASSESSMENTS_RESPONSE (state, response) {
    state.personAssessmentsResponse = response
  },

  resetPersonAssessments (state) {
    state.personAssessments = []
  },

  UPDATE_TRANSFERRED_ASSESSMENT (state, record) {
    state.viewAssessment = record
    // TO DO - Update personAssessments
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/assessments.js